const EXPIRED_COOKIE_DATE = 'Thu, 01 Jan 1970 00:00:00 GMT';

const buildExpiredCookieString = (
  name: string,
  options?: {
    httpOnly?: boolean;
    sameSite?: 'Lax' | 'None';
    secure?: boolean;
    partitioned?: boolean;
  }
) => {
  const segments = [
    `${name}=`,
    'Path=/',
    'Max-Age=0',
    `Expires=${EXPIRED_COOKIE_DATE}`,
  ];

  if (options?.sameSite) {
    segments.push(`SameSite=${options.sameSite}`);
  }

  if (options?.secure) {
    segments.push('Secure');
  }

  if (options?.httpOnly) {
    segments.push('HttpOnly');
  }

  if (options?.partitioned) {
    segments.push('Partitioned');
  }

  return segments.join('; ');
};

export const getExpiredCookieVariants = (name: string, options?: { httpOnly?: boolean }) => [
  buildExpiredCookieString(name, { httpOnly: options?.httpOnly }),
  buildExpiredCookieString(name, { httpOnly: options?.httpOnly, sameSite: 'Lax' }),
  buildExpiredCookieString(name, {
    httpOnly: options?.httpOnly,
    sameSite: 'None',
    secure: true,
  }),
  buildExpiredCookieString(name, {
    httpOnly: options?.httpOnly,
    sameSite: 'None',
    secure: true,
    partitioned: true,
  }),
];

export const expireBrowserCookie = (name: string) => {
  if (typeof document === 'undefined') return;

  getExpiredCookieVariants(name).forEach((cookieValue) => {
    document.cookie = cookieValue;
  });
};

export const appendExpiredCookieHeaders = (
  response: { headers: { append: (name: string, value: string) => void } },
  name: string,
  options?: { httpOnly?: boolean }
) => {
  getExpiredCookieVariants(name, options).forEach((cookieValue) => {
    response.headers.append('Set-Cookie', cookieValue);
  });
};

export const isLikelyAuthCookieName = (name: string) => {
  const normalized = name.trim().toLowerCase();
  return (
    normalized.startsWith('sb-') ||
    normalized.startsWith('sb_') ||
    normalized.includes('supabase') ||
    normalized.includes('auth-token')
  );
};